export default "__VITE_ASSET__5XQ4uBK5__"